"use strict";
$(function ($) {
  /* ドロワーメニュー */
  /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
    $('.header__logo').toggleClass('active'); // header__logo に active クラスを付与/削除
    $('.header__sub').toggleClass('active'); // header__sub に active クラスを付与/削除

    // bodyのスクロールを制御する
    if ($('#js-drawer-menu').hasClass('is-openSP')) {
      $('body').css('overflow', 'hidden'); // メニューが開いたらスクロール禁止
    } else {
      $('body').css('overflow', ''); // メニューが閉じたらスクロール許可
    }
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内のリンクをクリックしたらメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click');
  });
});


/* ----- ヘッダーアニメーション ----- */
$(function () {
  // ロゴ切り替え用のマークアップを追加
  const headerLogo = $('.header__logo');
  const originalLogo = headerLogo.find('img').attr('src');
  const changeLogoPath = originalLogo.replace('logo.webp', 'logo_change.webp');

  // 元のロゴ画像のHTMLを保存
  const originalLogoHTML = headerLogo.html();

  // 変更後のロゴ画像のHTMLを作成
  const changeLogoHTML = originalLogoHTML.replace('logo.webp', 'logo_change.webp');

  $(window).on('scroll', function () {
    const header = $('.header');
    const scrollTop = $(this).scrollTop();
    const fvHeight = $('.fv, .fvSub, .mv, .fvBranch').height();

    if (fvHeight < scrollTop) {
      // ファーストビューを過ぎたとき
      if (!header.hasClass('change-color')) {
        // まずヘッダーを非表示にする
        header.addClass('is-hidden');

        // 非表示になった後（200ms後）にスタイルとロゴを変更
        setTimeout(function() {
          header.addClass('change-color');
          headerLogo.html(changeLogoHTML); // ロゴを変更

          // スタイル変更後（50ms後）に再表示
          setTimeout(function() {
            header.removeClass('is-hidden');
          }, 50);
        }, 200);
      }
    } else {
      // ファーストビューに戻ったとき
      if (header.hasClass('change-color')) {
        // まずヘッダーを非表示にする
        header.addClass('is-hidden');

        // 非表示になった後（200ms後）に元のスタイルとロゴに戻す
        setTimeout(function() {
          header.removeClass('change-color');
          headerLogo.html(originalLogoHTML); // 元のロゴに戻す

          // スタイル変更後（50ms後）に再表示
          setTimeout(function() {
            header.removeClass('is-hidden');
          }, 50);
        }, 200);
      }
    }
  });
});




/* ----- QAアコーディオン ----- */
$(".topQa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});


/* ----- linkの表示、非表示 ----- */
document.addEventListener('DOMContentLoaded', function() {
  // 対象の要素を取得
  const linkElement = document.querySelector('.link');
  const mvElement = document.querySelector('.mv');
  const fvBranchElement = document.querySelector('.fvBranch');
  const bottomCtaElement = document.querySelector('.bottomCta');

  // 必要な要素がない場合は終了
  if (!linkElement || (!mvElement && !fvBranchElement) || !bottomCtaElement) {
    return;
  }

  // トリガー要素の設定
  const triggerElement = mvElement || fvBranchElement;

  // スクロールハンドラーの定義
  function handleScroll() {
    const scrollPosition = window.scrollY;

    // トリガー要素の直後に表示開始
// 要素の高さの半分の位置で表示開始
const triggerPosition = triggerElement.offsetTop + (triggerElement.offsetHeight * 0.5);
    // BottomCta手前で非表示
    const hidePosition = bottomCtaElement.offsetTop - 800;

    // 条件判定をシンプルに
    if (scrollPosition > triggerPosition && scrollPosition < hidePosition) {
      linkElement.classList.add('is-active');
    } else {
      linkElement.classList.remove('is-active');
    }
  }

  // 初期状態で一度実行
  handleScroll();

  // パフォーマンス向上のため直接スクロールイベントに登録
  window.addEventListener('scroll', handleScroll, { passive: true });

  // リサイズ時にも再計算
  window.addEventListener('resize', handleScroll, { passive: true });
});


// /* ----- スムースクロール ----- */
// document.addEventListener('DOMContentLoaded', function() {
//   // 固定ヘッダー（固定しない場合は = 0）
//   const headerElement = document.querySelector('header');
//   const headerHeight = headerElement ? headerElement.offsetHeight : 0; // ヘッダーが存在しない場合は0に設定

//   // スマホサイズの時の追加オフセット（必要に応じて調整）
//   const mobileOffset = -10; // 10px 追加オフセット
//   // PCサイズの時の追加オフセット（必要に応じて調整）
//   const pcOffset = -50; // 5px 上に調整

//   // ページ内のスムーススクロール
//   const anchorLinks = document.querySelectorAll('a[href*="#"]');

//   if (anchorLinks && anchorLinks.length > 0) {
//     anchorLinks.forEach(link => {
//       link.addEventListener('click', (e) => {
//         const hash = e.currentTarget.hash;

//         // ページトップへ("#"と"#top"）
//         if (!hash || hash === '#top') {
//           e.preventDefault();
//           window.scrollTo({
//             top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
//             behavior: 'smooth',
//           });
//         }
//         // アンカーへ
//         else if (hash.slice(1)) {
//           const target = document.getElementById(hash.slice(1));
//           if (target) {
//             e.preventDefault();
//             let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

//             // スマホサイズの場合の追加オフセット
//             if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
//               position += mobileOffset;
//             } else {
//               // PCサイズの場合の追加オフセット
//               position += pcOffset;
//             }

//             window.scrollTo({
//               top: position,
//               behavior: "smooth",
//             });

//             // URLにハッシュを含める
//             history.pushState(null, '', hash);
//           }
//         }
//       });
//     });
//   }
// });



/* ----- トップ FVスライダー ----- */
new Swiper(".swiper__fv", {
  effect: "fade", // フェードエフェクト
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: true,
  speed: 1000,
  allowTouchMove: false // タッチ操作無効化
});

/* ----- 自由設計 MVスライダー ----- */
new Swiper(".swiper__mv", {
  effect: "fade", // フェード
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: true, // rewind と同様
  speed: 1000,
  allowTouchMove: false, // タッチ操作無効化（必要であれば）
  pagination: {
    el: ".swiper-pagination", // ページネーションを表示したい場合に使用
    clickable: true,
  },
});


/* ----- トップイベント情報 ----- */
document.addEventListener('DOMContentLoaded', function () {
  var sliderElement = document.querySelector('#topEventSlider');
  if (sliderElement) {
    new Swiper('#topEventSlider', {
      loop: true,
      slidesPerView: 1.4,
      spaceBetween: 36, // gap: '3.6rem' と同等 (px単位)
      centeredSlides: true, // focus: 'center' に相当
      speed: 400,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next-information',
        prevEl: '.swiper-button-prev-information',
      },
      breakpoints: {
        767: {
          slidesPerView: 3.6,
          spaceBetween: 36,
          centeredSlides: true,
        },
        1200: {
          slidesPerView: 5.5,
          spaceBetween: 36,
          centeredSlides: true,
        },
      },
    });
  }
});

// /* ----- １５のポイントスライダー ----- */
// document.addEventListener('DOMContentLoaded', function () {
//   var sliderElement = document.querySelector('.topPoint__swiper');
//   if (sliderElement) {
//     new Swiper('.topPoint__swiper', {
//       loop: true,
//       slidesPerView: 1,
//       spaceBetween: 20,
//       centeredSlides: true,
//       speed: 500,
//       pagination: false,
//       // autoHeight: true,
//       navigation: {
//         nextEl: '.swiper-button-next-point',
//         prevEl: '.swiper-button-prev-point',
//       },
//       breakpoints: {
//         750: {
//           slidesPerView: 3,
//           spaceBetween: 20,
//           centeredSlides: true,
//           // autoHeight: false,
//         },
//         1200: {
//           slidesPerView: 3,
//           spaceBetween: 50,
//           centeredSlides: true,
//           // autoHeight: false,
//         },
//         1600: {
//           slidesPerView: 3,
//           spaceBetween: 126,
//           centeredSlides: true,
//           // autoHeight: false,
//         },
//       },
//     });
//   }
// });


// /* ----- shoolの背景変化 ----- */
// document.addEventListener('DOMContentLoaded', function () {
//   const sectionNeed = document.querySelector('section.need');
//   const footer = document.querySelector('footer');
//   const firstBg = document.querySelector('.singleSchool__bg.first');
//   const secondBg = document.querySelector('.singleSchool__bg.second');

//   if (sectionNeed && footer) {  // 要素が存在する場合のみ実行
//     function checkPosition() {
//       const needTop = sectionNeed.getBoundingClientRect().top;
//       const footerTop = footer.getBoundingClientRect().top;
//       const windowHeight = window.innerHeight;

//       if (footerTop <= windowHeight) {
//         secondBg.classList.remove('active');
//       } else if (needTop <= windowHeight && needTop > 0) {
//         firstBg.classList.remove('active');
//         secondBg.classList.add('active');
//       } else if (needTop > windowHeight) {
//         secondBg.classList.remove('active');
//         firstBg.classList.add('active');
//       } else if (needTop <= 0) {
//         firstBg.classList.remove('active');
//         secondBg.classList.add('active');
//       }
//     }
//     window.addEventListener('scroll', checkPosition);
//     checkPosition();  // 初期ロード時に位置を判定
//   }
// });


// /* ----- 取得できる資格詳細タイトルの英文字判別 ----- */
// document.addEventListener("DOMContentLoaded", () => {
//   const elements = document.querySelectorAll("h2.fvSub__en");

//   elements.forEach((element) => {
//     const text = element.textContent.trim();
//     const isEnglish = /^[A-Za-z\s]+$/.test(text); // 英文字とスペースのみか判定

//     if (!isEnglish) {
//       element.classList.add("non-english");
//     }
//   });
// });




/* ----- カテゴリーボタンのアクティブ状態を管理するスクリプト ----- */
document.addEventListener('DOMContentLoaded', function() {
  // URLからカテゴリーを判定してアクティブクラスを設定
  const categoryItems = document.querySelectorAll('.categoryBtn__item');
  const currentPath = window.location.pathname;

  // categoryItemsが存在する場合のみ処理
  if (categoryItems && categoryItems.length > 0) {
    // カテゴリーページかどうかをチェック
    if (currentPath.indexOf('/category/') !== -1) {
      // ALLボタンのアクティブ状態を解除
      const allButton = document.querySelector('.categoryBtn__item:first-child');
      if (allButton) {
        allButton.classList.remove('is-active');
      }

      // 現在のカテゴリーのパスと一致する項目をアクティブに
      categoryItems.forEach(item => {
        const link = item.querySelector('a');
        if (link && currentPath.includes(link.getAttribute('href'))) {
          item.classList.add('is-active');
        }
      });
    } else if (currentPath === '/' || currentPath.match(/\/page\/\d+\/?$/) || currentPath.endsWith('/posts/')) {
      // ホームページまたはメインの投稿アーカイブページの場合、ALLをアクティブに
      const allButton = document.querySelector('.categoryBtn__item:first-child');
      if (allButton) {
        allButton.classList.add('is-active');
      }
    }

    // クリックイベントでアクティブクラスを更新
    categoryItems.forEach(item => {
      const link = item.querySelector('a');
      if (link) { // aタグが存在する場合のみイベントを追加
        link.addEventListener('click', function() {
          // 現在のアクティブなアイテムからクラスを削除
          document.querySelectorAll('.categoryBtn__item.is-active').forEach(activeItem => {
            activeItem.classList.remove('is-active');
          });

          // クリックされたアイテムにアクティブクラスを追加
          item.classList.add('is-active');
        });
      }
    });
  }
});


/* ----- このコードはWordPressのpagination内に投稿数を表示するためのものです ----- */
document.addEventListener('DOMContentLoaded', function() {
  // pagination要素を取得
  const paginationElement = document.querySelector('.pagination');

  if (paginationElement) {
    // 投稿数の情報を取得（この値はPHPから出力する必要があります）
    // アーカイブページの場合とカテゴリ/タグページの場合で異なる可能性があるため、
    // PHPでdata属性として投稿数を設定することをお勧めします

    // PHPコードに追加する部分（HTML出力時に投稿数をdata属性として追加）:
    // <div class="pagination" data-total-posts="<?php echo $the_query->found_posts; ?>">

    // JavaScriptで投稿数を取得
    const totalPosts = paginationElement.getAttribute('data-total-posts');

    // 投稿数表示要素の作成
    const totalElement = document.createElement('div');
    totalElement.className = 'total';
    totalElement.textContent = `全 ${totalPosts} 件`;

    // pagination要素に追加
    paginationElement.appendChild(totalElement);

    // スタイリングの例（CSSに追加、または既存のスタイルに合わせて調整）
    // .pagination .total {
    //   margin-top: 1rem;
    //   text-align: center;
    //   font-size: 0.875rem;
    // }
  }
});



/* ----- room_tour モーダル ----- */
document.addEventListener('DOMContentLoaded', function() {
  // 要素の取得
  const roomItems = document.querySelectorAll('.room__item');
  const roomVideos = document.querySelectorAll('.room__video');
  const modal = document.querySelector('.room-modal');

  // 必要な要素がない場合は処理を終了
  if (!roomItems.length || !roomVideos.length || !modal) {
    return;
  }

  const modalContent = document.querySelector('.room-modal__content');
  const closeButton = document.querySelector('.room-modal__close');

  // 必要な子要素がない場合も処理を終了
  if (!modalContent || !closeButton) {
    return;
  }

  // サムネイルクリックでモーダル表示
  roomItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      // 対応するビデオのiframeを取得
      if (roomVideos[index]) {
        const videoIframe = roomVideos[index].querySelector('iframe');
        if (videoIframe) {
          // iframeをクローンして、モーダルに挿入
          const clonedIframe = videoIframe.cloneNode(true);

          // 自動再生を追加
          let src = clonedIframe.src;
          if (src.indexOf('?') > -1) {
            src += '&autoplay=1';
          } else {
            src += '?autoplay=1';
          }
          clonedIframe.src = src;

          // モーダルにコンテンツを挿入
          modalContent.innerHTML = '';
          modalContent.appendChild(clonedIframe);

          // モーダルを表示
          modal.classList.add('is-active');
          document.body.classList.add('modal-open');

          // headerを非表示にする
          const header = document.querySelector('header');
          if (header) {
            header.style.display = 'none';
          }
        }
      }
    });
  });

  // モーダルを閉じる
  closeButton.addEventListener('click', closeModal);

  // モーダルの背景をクリックしても閉じる
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // ESCキーでも閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });

  // モーダルを閉じる関数
  function closeModal() {
    modal.classList.remove('is-active');
    document.body.classList.remove('modal-open');

    // headerを再表示する
    const header = document.querySelector('header');
    if (header) {
      header.style.display = '';
    }

    // iframe内の動画を停止するために、コンテンツを空にする
    setTimeout(() => {
      modalContent.innerHTML = '';
    }, 300);
  }
});



// /* ----- モデルハウス無限ループ ----- */
// // DOMの読み込み完了後に実行
// document.addEventListener('DOMContentLoaded', function() {
//   // 各スライダーを取得
//   const sliders = document.querySelectorAll('.topModel__slider');

//   // 各スライダーに対して処理
//   sliders.forEach(slider => {
//     // オリジナルのスライドを取得
//     const originalSlides = [...slider.querySelectorAll('.topModel__slide')];

//     // 各スライドの合計幅を計算
//     let totalWidth = 0;
//     originalSlides.forEach(slide => {
//       const width = slide.offsetWidth;
//       const gap = 2; // スライド間のギャップ
//       totalWidth += width + gap;
//     });

//     // 十分なクローンを作成するために必要な数を計算
//     // 画面の幅の3倍以上をカバーするようにする
//     const screenWidth = window.innerWidth * 3;
//     const numCopiesNeeded = Math.ceil(screenWidth / totalWidth);

//     // 安全のために最低8セット以上のクローンを作成
//     const minCopies = 2;
//     const copies = Math.max(numCopiesNeeded, minCopies);

//     // クローンを作成して追加
//     for (let i = 0; i < copies; i++) {
//       originalSlides.forEach(slide => {
//         const clone = slide.cloneNode(true);
//         slider.appendChild(clone);
//       });
//     }

//     // スライダーの新しい全体幅を計算
//     const newTotalWidth = totalWidth * (copies + 1); // オリジナル + クローン

//     // アニメーション時間を調整（幅に比例）
//     let duration = Math.max(60, newTotalWidth / 50); // 最低60秒、幅に応じて増加

//     // 逆方向スライダーの場合は初期位置を設定
//     if (slider.classList.contains('topModel__slider-reverse')) {
//       // 逆方向スライダーの場合は初期位置を設定
//       slider.style.transform = 'translateX(-100%)';

//       // アニメーションをクリアして再設定
//       slider.style.animation = 'none';

//       // リフロー（再描画）を強制
//       void slider.offsetWidth;

//       // アニメーションを再設定
//       slider.style.animation = `slideReverse ${duration}s linear 0s infinite`;
//     } else {
//       // 通常方向のスライダー
//       slider.style.animation = 'none';
//       void slider.offsetWidth;
//       slider.style.animation = `slideShow ${duration}s linear 0s infinite`;
//     }
//   });
// });


/* ----- モデルハウス無限ループ修正版 ----- */
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.topModel__slider');

  sliders.forEach(slider => {
    const originalSlides = [...slider.querySelectorAll('.topModel__slide')];

    // 各スライドの合計幅を計算（ギャップ込み）
    let totalWidth = 0;
    originalSlides.forEach(slide => {
      const computedStyle = window.getComputedStyle(slide);
      const width = slide.offsetWidth;
      const marginRight = parseInt(computedStyle.marginRight) || 0;
      totalWidth += width + marginRight + 2; // 2pxはgap
    });

    // 画面幅の4倍分をカバーする十分なクローンを作成
    const screenWidth = window.innerWidth;
    const numCopiesNeeded = Math.ceil((screenWidth * 4) / totalWidth);
    const copies = Math.max(numCopiesNeeded, 3); // 最低3セット

    // クローンを作成
    for (let i = 0; i < copies; i++) {
      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        slider.appendChild(clone);
      });
    }

    // アニメーション設定
    const isReverse = slider.classList.contains('topModel__slider-reverse');
    const duration = 120; // アニメーション時間を固定（秒）

    // 既存のアニメーションをクリア
    slider.style.animation = 'none';
    slider.style.transform = 'translateX(0)';

    // リフローを強制
    void slider.offsetWidth;

    if (isReverse) {
      // 逆方向スライダーの初期位置を調整
      slider.style.transform = `translateX(0)`;
      slider.style.animation = `slideReverse ${duration}s linear infinite`;
    } else {
      // 通常方向スライダー
      slider.style.animation = `slideShow ${duration}s linear infinite`;
    }
  });
});

// CSSのキーフレームも調整が必要な場合は、以下を追加
const style = document.createElement('style');
style.textContent = `
  @keyframes slideShow {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  @keyframes slideReverse {
    0% {
      transform: translateX(-50%);
    }
    100% {
      transform: translateX(0);
    }
  }
`;
document.head.appendChild(style);


/* ----- rem → px 変換関数 ----- */
function remToPx(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

/* ----- topGuarantee スライダー ----- */
document.addEventListener('DOMContentLoaded', function () {
  var guaranteeSlider = document.querySelector('.topGuarantee__swiper');

  if (guaranteeSlider) {
    new Swiper('.topGuarantee__swiper', {
      // 基本設定
      loop: true,
      speed: 500,
      spaceBetween: 30,

      // 自動再生
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true, // マウスホバーで一時停止
      },

      // レスポンシブ設定
      slidesPerView: 1.3, // SP: 1枚表示
      centeredSlides: false,

      // ブレークポイント
      breakpoints: {
        768: {
          // PC: 複数表示でスクロール効果
          slidesPerView: '1.3',
          spaceBetween: remToPx(13), // rem を px に変換
          centeredSlides: false,
          freeMode: false, // 自由スクロールを無効化
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true, // マウスホバーで一時停止
          },
        },
      },

      // イベント
      on: {
        init: function() {
          // 初期化完了後の処理
          console.log('topGuarantee Swiper initialized');
        },

        slideChange: function() {
          // スライド変更時の処理（必要に応じて）
          // console.log('Slide changed to:', this.activeIndex);
        },

        // マウスエンターでオートプレイ停止
        mouseenter: function() {
          if (window.innerWidth >= 768) {
            this.autoplay.stop();
          }
        },

        // マウスリーブでオートプレイ再開
        mouseleave: function() {
          if (window.innerWidth >= 768) {
            this.autoplay.start();
          }
        }
      }
    });
  }
});
